import { render, staticRenderFns } from "./UcProjectGeneral.yaml?vue&type=template&id=a2a2b2da&component"
import script from "./UcProjectGeneral.yaml?vue&type=script&lang=ts&component"
export * from "./UcProjectGeneral.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports